import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { tamanioGrafica } from "utils/generalFunctions";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarchartProduccionEstimada = ({ menuLateral, data2 }) => {
  const [datos, setDatos] = useState(null);
  const [labelsGrafica, setLabelsGrafica] = useState(["s", "d", "d", "d"]);
  const [maxYGrafica, setmaxYGrafica] = useState(0);
  const [datosGrafica, setDatosGrafica] = useState([]);

  useEffect(() => {
    setDatos([...data2]);
  }, [data2]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
    },
    scales: {
      y: {
        min: 0,
        max: maxYGrafica,
      },
      x: {
        ticks: { color: "rgb(135, 135, 135)" },
      },
    },
  };

  useEffect(() => {
    let labelsHoras = [];
    let datosGrafica = [];

    datos?.forEach((dato) => {
      labelsHoras.push(dato.fecha);
      datosGrafica.push(Math.abs(dato.energiaGenerada));
    });

    setLabelsGrafica([...labelsHoras]);
    setDatosGrafica([...datosGrafica]);
    let maximoY = 0;
    if (datos?.length > 0) {
      maximoY = datos?.reduce((previous, current) => {
        return current.periodo > previous.periodo ? current : previous;
      });
    }

    setmaxYGrafica(Math.round(maximoY?.periodo / 1000) * 1000);
  }, [datos]);

  const labels = labelsGrafica;

  const data = {
    labels,
    datasets: [
      {
        label: "Potencia",
        data: datosGrafica,
        backgroundColor: "rgb(75, 138, 169)",
      },
    ],
  };

  return (
    <div className="w-100 flex justify-center pl-md-5 pr-md-5">
      <Bar height={tamanioGrafica(menuLateral)} options={options} data={data} />
    </div>
  );
};

export default BarchartProduccionEstimada;
